// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 27,
  argument: "Dangers of sin from several heads: the fear of God is the best preservative. He that diggeth a pit, shall fall into it.",
  verses: [
    { n: 1, text: "Through poverty many have sinned: and he that seeketh to be enriched, turneth away his eye." },
    { n: 2, text: "As a stake sticketh fast in the midst of the joining of stones, so also in the midst of selling and buying, sin shall stick fast." },
    { n: 3, text: "Sin shall be destroyed with the sinner." },
    { n: 4, text: "Unless thou hold thyself diligently in the fear of the Lord, thy house shall quickly be overthrown." },
    { n: 5, text: "As when one sifteth with a sieve, the dust will remain: so will the perplexity of a man in his thoughts." },
    { n: 6, text: "The furnace trieth the potter's vessels, and the trial of affliction just men." },
    { n: 7, text: "As the dressing of a tree sheweth the fruit thereof, so a word out of the thought of the heart of man." },
    { n: 8, text: "Praise not a man before he speaketh, for this is the trial of men." },
    { n: 9, text: "If thou followest justice, thou shalt obtain her: and shalt put her on as a long robe of honour, and thou shalt dwell with her: and she shall protect thee for ever, and in the day of acknowledgment thou shalt find a strong foundation." },
    { n: 10, text: "Birds resort unto their like: so truth will return to them that practise her." },
    { n: 11, text: "The lion always lieth in wait for prey: so do sins for them that work iniquities." },
    { n: 12, text: "A holy man continueth in wisdom as the sun: but a fool is changed as the moon." },
    { n: 13, text: "In the midst of the unwise keep in the word till its time: but be continually among men that think." },
    { n: 14, text: "The discourse of sinners is hateful, and their laughter is at the pleasures of sin." },
    { n: 15, text: "The speech that sweareth much shall make the hair of the head stand upright: and its irreverence shall make one stop his ears." },
    { n: 16, text: "In the quarrels of the proud is the shedding of blood: and their cursing is a grievous hearing." },
    { n: 17, text: "He that discloseth the secret of a friend, loseth his credit, and shall never find a friend to his mind." },
    { n: 18, text: "Love thy neighbour, and be joined to him with fidelity." },
    { n: 19, text: "But if thou discover his secrets, follow no more after him." },
    { n: 20, text: "For as a man that destroyeth his friend, so also is he that destroyeth the friendship of his neighbour." },
    { n: 21, text: "And as one that letteth a bird go out of his hand, so hast thou let thy neighbour go, and thou shalt not get him again." },
    { n: 22, text: "Follow after him no more, for he is gone afar off, he is fled, as a roe escaped out of the snare: because his soul is wounded." },
    { n: 23, text: "Thou canst no more bind him up. And of a curse there is reconciliation:" },
    { n: 24, text: "But to disclose the secrets of a friend leaveth no hope to an unhappy soul." },
    { n: 25, text: "He that winketh with the eye forgeth wicked things, and no man will cast him off:" },
    { n: 26, text: "In the sight of thy eyes he will sweeten his mouth, and will admire thy words: but at the last he will writhe his mouth, and on thy words he will lay a stumbling-block." },
    { n: 27, text: "I have hated many things, but not like him, and the Lord will hate him." },
    { n: 28, text: "If one cast a stone on high, it will fall upon his own head: and the deceitful stroke will wound the deceitful." },
    { n: 29, text: "He that diggeth a pit, shall fall into it: and he that setteth a stone for his neighbour, shall stumble upon it: and he that layeth a snare for another, shall perish in it." },
    { n: 30, text: "A mischievous counsel shall be rolled back upon the author, and he shall not know from whence it cometh to him." },
    { n: 31, text: "Mockery and reproach are of the proud, and vengeance as a lion shall lie in wait for him." },
    { n: 32, text: "They shall perish in a snare that are delighted with the fall of the just: and sorrow shall consume them before they die." },
    { n: 33, text: "Anger and fury are both of them abominable, and the sinful man shall be subject to them." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Poverty. Greek, \"the indifferent thing,\" as the Stoics represented money, chap. vii. 20. — Sinned. Hence proceeds the danger to which little merchants are exposed. Involuntary povery is very miserable, Proverbs xxx. 9", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "Fast. Anacharsis styled \"the market-place the receptacle of mutual cheating.\" (Laertius 1.) — The seller praises his goods to get them off: (Horace) the buyer says it is bad, Proverbs xx. 14. The next verse is a gloss omitted in Greek.", attribution: "Calmet" }
    ] },
    { verse: 4, notes: [
      { text: "Fear. By this the soul is preserved in a good state.", attribution: "Worthington" }
    ] },
    { verse: 5, notes: [
      { text: "Thoughts. The more he thinks on some things, the more is he perplexed. (Calmet) — After sin is purged away, there remains some defects like dust, Psalm l. 4.", attribution: "Worthington" }
    ] },
    { verse: 6, notes: [
      { text: "Affliction. Greek, \"thought,\" (Haydock) or speech. (Calmet) — A young man being brought to Socrates, that he might pass judgment on his dispositions, the philosopher ordered him to \"speak.\"", attribution: "Cicero" }
    ] },
    { verse: 7, notes: [
      { text: "As. Greek, \"the fruit shews the dressing,\" &c.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Honour. The desire of justice is the sure method to obtain it. The rest is not in Greek.", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Iniquities. They fall deeper, or sin entails punishment.", attribution: "Calmet" }
    ] },
    { verse: 12, notes: [
      { text: "A. Greek, \"the speech of the wise man is wisdom throughout: but,\" &c. (Haydock) — The fool always mixes something improper with what good he speaks. (Calmet) — Sun. The wise man preserves his virtue, whether it appear or not.", attribution: "Worthington" }
    ] },
    { verse: 13, notes: [
      { text: "Keep. Greek, \"wait an opportunity.\" (Haydock) — Go but seldom. Their discourse tends to promote iniquity, (", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: ") and blasphemous oaths, (", attribution: "Haydock" }
    ] },
    { verse: 15, notes: [
      { text: ") and bloodshed,", attribution: "Haydock" }
    ] },
    { verse: 17, notes: [
      { text: "Mind. In Egypt, those who disclosed a secret to the enemy, were condemned to have their tongues cut out.", attribution: "Diodorus ii. 2." }
    ] },
    { verse: 19, notes: [
      { text: "Him. He will never trust thee more,", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "Friend. Roman and Alexandrian Septuagint, \"enemy.\" (Haydock) — This crime is like murder. The Romans sometimes solemnly renounced the friendship of those who had offended them, as Germanicus and Caius did that of Piso.", attribution: "Tacitus, An. 2.; Suetonius 3." }
    ] },
    { verse: 25, notes: [
      { text: "Off. Some Greek copies have, \"he who knows him will depart from him.\" It is difficult to guard against a false friend, who winks as if he desired to please us, (Calmet) while he really seeks our ruin,", attribution: "Haydock" }
    ] },
    { verse: 28, notes: [
      { text: "Wound. Greek, \"deal wounds. He,\" &c. (Haydock) — Traitors, in the dark, often wound their fellows, (Calmet) or themselves.", attribution: "Menochius" }
    ] },
    { verse: 29, notes: [
      { text: "Setteth. Greek, \"layeth a snare, shall perish in it.\"", attribution: "Haydock" }
    ] },
    { verse: 30, notes: [
      { text: "Him. God will punish, when the sinner has perhaps forgotten his offence. (Calmet) — Such are often chastised here, and always hereafter.", attribution: "Worthington" }
    ] },
    { verse: 33, notes: [
      { text: "Them. He shall feel the indignation of God, (Calmet) and shall repine.", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
